import { cva } from 'cva';

import { Popover, type PopoverProps } from '../popover/popover';
import {
  type BaseDropdownListProps,
  DropdownListContent,
} from './dropdown_list_content';

import styles from './searchable_dropdown_list.module.css';

const popoverVariants = cva({
  variants: {
    matchTriggerWidth: {
      true: styles.popover_match_trigger_width,
      false: styles.popover_default_width,
    },
  },
});

export type DropdownListProps = BaseDropdownListProps &
  Omit<PopoverProps, 'children' | 'className' | 'maxHeight'> & {
    matchTriggerWidth?: boolean;
    className?: string;
  };

export function DropdownList({
  options,
  selectionMode,
  size,
  optionsListLabel,
  noResultsText,
  loadingText,
  renderOption,
  isLoading,
  onLoadMore,
  matchTriggerWidth = false,
  className,
  placement = 'bottom end',
  maxHeight = 210,
  ...popoverProps
}: DropdownListProps) {
  const contentProps = {
    options,
    selectionMode,
    size,
    optionsListLabel,
    noResultsText,
    loadingText,
    renderOption,
    isLoading,
    onLoadMore,
    maxHeight,
  };

  return (
    <Popover
      {...popoverProps}
      className={popoverVariants({ matchTriggerWidth, className })}
      placement={placement}
    >
      <DropdownListContent {...contentProps} />
    </Popover>
  );
}
